import img1 from "../../images/ntvk.JPG";
import img2 from "../../images/merkuriusz.JPG";
import img3 from "../../images/counciller.JPG";
import img4 from "../../images/ntvk.JPG";

export default [
  {
    id: 1,
    name: "Ntvk Project",
    description:
      "This is Ntvk static page and made up of using Bootstrap,jquery,HTML5 and CSS3.",
    code_link: "https://github.com/nagireddy1234/Ntvk",
    deploy_link: "http://www.ntvk.com.pl/",
    tools: ["Bootstrap", "jQuery", "HTML5", "CSS3"],
    icons: ["Bootstrap", "HTML5"],
    image: img1,
    image_describe: "NTVK",
  },
  {
    id: 2,
    name: "Merkuriusz Project",
    description:
      "This is an advertising website and statatic page. It is made up of using Bootstrap,jquery,HTML5 and CSS3",
    code_link: "https://github.com/nagireddy1234/Merkuriusz",
    deploy_link: "http://merkuriusz.pl/",
    tools: ["Bootstrap", "jQuery", "HTML5", "CSS3"],
    icons: ["Bootstrap", "HTML5"],
    image: img2,
    image_describe: "Merkuriusz",
  },
  {
    id: 3,
    name: "Councillor Project",
    description:
      " Its simple portfolio of an councillor of muncipolity and it is made up of using Bootstrap,jquery and aimation ",
    code_link: "https://github.com/nagireddy1234/raflkmal",
    deploy_link: "https://nagireddy1234.github.io/raflkmal/",
    tools: ["Bootstrap", "jQuery", "HTML5", "CSS3"],
    icons: ["Bootstrap", "HTML5"],
    image: img3,
    image_describe: "councillor",
  },
  {
    id: 4,
    name: " Lawyer Project",
    description:
      "This is my first website made up of using Bootstrap , jquery and CSS.",
    code_link: "https://github.com/nagireddy1234/Lawyer",
    deploy_link: "https://nagireddy1234.github.io/Lawyer/",
    tools: ["Bootstrap", "jQuery", "HTML5", "CSS3"],
    icons: ["Bootstrap", "HTML5"],
    image: img4,
    image_describe: "lawyer",
  },
];
